import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Console } from 'console';
import { ConfirmationService, MessageService } from 'primeng/api';
import { retry } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services';
import { ApiService } from 'src/app/api.service';
import * as CryptoJS from "crypto-js";
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { SchoolFpgDataVO } from 'src/app/shared/models/SchoolFPGDataVO';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { Usuario } from 'src/app/shared/models/Usuario';
import { Constants } from 'src/app/shared/vo/Constants';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';

@Component({
  selector: 'app-userslst',
  templateUrl: './userslst.component.html',
  styleUrls: ['./userslst.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class UserslstComponent implements OnInit {


  /** Security */
  currentUser: any;
  security: SecurityDocument;

  /** Labels */
  lbl_go_Back: string = "back_";
  lbl_total: string = "total_";
  lbl_records: string = "records_";
  lbl_showing: string = "showing_";
  lbl_status: string = "status_";
  lbl_of: string = "of_";
  lbl_login: string = "Login_";
  lbl_name: string = "name_";
  lbl_last_name: string = "last_name_";
  lbl_type: string = "type_";
  lbl_guideId: string = "guideId_";
  lbl_email: string = "email_";
  lbl_vendor: string = "vendor_";
  lbl_edit: string = "edit_";
  lbl_delete_record: string = "delete_record_";
  lbl_users: string = "users_";
  lbl_new_record: string = "new_record_";
  lbl_save: string = "save_";
  lbl_back: string = "back_";
  lbl_detail: string = "detail_";
  lbl_user: string = "user_";
  lbl_confirm: string = "confirm_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_yes: string = "yes_";
  lbl_no: string = "no_";
  lbl_loading: string = "loading_";
  lbl_search: string = "search_";
  lbl_entry: string = "entry_";
  lbl_userId: string = "userId_";
  lbl_password: string = "password_";
  lbl_updated_data: string = "updated_data_";
  lbl_record: string = "record_";
  lbl_deleted: string = "deleted_";


  //Usuarios
  Usuario: Usuario;
  tmpPassword: string;
  usuarioDocList: Usuario[];

  lstGuides: any[];
  selectedGuide: any;
  filteredGuides: any[];
  showGuides: boolean;

  lstSuppliers: any[];
  selectedSupplier: any;
  showSuppliers: boolean;


  selectedUsuario: Usuario;
  selectedlogin: Usuario[];


  optionDialog: boolean;
  submitted: boolean;
  mailValid: boolean;

  userView: Usuario;


  listLanguage: CategoryLan[];
  selectedLanguage: CategoryLan;
  listFunctions: CategoryLan[];
  selectedFunction: CategoryLan;
  listUserTypes: any[];
  selectedUserType: any;
  blocked: boolean = true;

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService,
    private filesService: TovpilFilesService,
    private authenticationService: AuthenticationService,
  ) { }

  ngOnInit(): void {

    this.currentUser = this.authenticationService.currentUserValue;
    this.getSecurity();

  }

  loadUsuario() {
    this.blocked = true;

    const requestParams = {
      "storeId": this.security.storeId
    };

    this.apiService.listUsersByLevelStore(requestParams)
      .then(responseData => {
        this.usuarioDocList = responseData;
        console.log(this.usuarioDocList);

        // Data manipulation similar to lstCordinationCatalog
        const listUsuarios = this.usuarioDocList.filter(user => (user.status == "A" || user.status == "B"));
        this.usuarioDocList = listUsuarios;
        console.log(this.usuarioDocList);

      })
      .catch(error => {
        console.error("An error occurred while fetching user data:", error);
        this.handleError();
      })
      .finally(() => {
        setTimeout(() => {
          this.blocked = false;
        }, 1500);
      });
  }


  private handleError() {
    //this.goBack();
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'system error',
      summary: 'system Error',
      detail: 'system error: Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.',
      life: 5000
    });
  }

  hideDialog() {
    this.optionDialog = false;
    this.submitted = false;
  }

  createUser() {
    // Se setean las propiedades
    this.userView = {};
    this.submitted = false;
    this.showGuides = true;
    this.showSuppliers = false;
    this.tmpPassword = null;
    this.selectedGuide = {};
    this.selectedSupplier = {};
    // Se activa el modal
    this.optionDialog = true;
  }

  editUser(user: Usuario) {
    this.userView = { ...user };
    this.optionDialog = true;
    this.tmpPassword = this.userView.clave;
    this.userView.clave = '';
    this.selectedUserType = this.listUserTypes.find(s => s.valueId === this.userView.rol);
    if (this.userView.guideId) {
      this.selectedGuide = this.lstGuides.find(s => s.guideId === this.userView.guideId);
    }
    this.showSupplOrGuide();
  }

  listCategoryTranslation(fieldId: string) {
    this.apiService.listCategoryTranslation({
      "fieldId": fieldId,
      "language": this.security.language
    }).then(
      data => {
        if (fieldId == "usrTypes") {
          this.listUserTypes = data;
          if (this.security.levelId != Constants.INTNAL_LEVELID) {
            
            this.listUserTypes = this.listUserTypes.filter((tip) => tip.valueId == Constants.USER__TYPE_GUI_FG);
          }
          this.selectedUserType = this.listUserTypes[0];
          
        } else if (fieldId == "Function") {

        } else if (fieldId == "incUsrTyp") {

        }
      })
  }

  createUsuario() {
    this.submitted = true;
    this.userView.rol = this.selectedUserType.valueId;
    if (this.userView.clave) {
      this.userView.clave = CryptoJS.MD5(this.userView.clave).toString();
    } else {
      this.userView.clave = this.tmpPassword;
    }

    if (this.selectedGuide && this.selectedGuide.guideId) {
      this.userView.guideId = this.selectedGuide.guideId;
      this.userView.name = this.selectedGuide.guideName;
      this.userView.lastName = this.selectedGuide.guideLastName;
      this.userView.email = this.selectedGuide.guideEmail;
    }
    if (this.selectedSupplier && this.selectedSupplier.supplId) {
      this.userView.supplId = this.selectedSupplier.supplId;
      this.userView.name = this.selectedSupplier.name;
      this.userView.lastName = '-';
      this.userView.email = this.selectedGuide.email1;
    }
    if (this.userView.status) {

      this.apiService.updateUser(this.userView).then(
        data => {
          if (data && data.status && (data.status == Constants.EXCEPTION_ERROR || data.status == Constants.ERRORSTATUS)) {
            this.messageService.add({ severity: 'system error', summary: 'system error', detail: data.errorMessage, life: 9000 });
          } else {
            this.loadUsuario();
            this.optionDialog = false;
            this.userView = {};
            //this.messageService.add({ severity: 'success', summary: 'Datos actualizados', detail: ' ', life: 3000 });
            this.messageService.add({ severity: 'success', summary: this.lbl_updated_data,  detail: ' ', life: 3000 });
          }
        })

    } else {

      this.userView.status = "A";
      this.apiService.createUser2(this.userView).then(
        data => {
          if (data && data.status && data.errorMessage && (data.status == Constants.EXCEPTION_ERROR || data.status == Constants.ERRORSTATUS)) {
            this.messageService.add({ severity: 'system error', summary: 'Error', detail: data.errorMessage, life: 9000 });
          } else {
            this.optionDialog = false;
            this.userView = {};
            this.messageService.add({ severity: 'success', summary: this.lbl_record + this.lbl_updated_data, detail: ' ', life: 3000 });
            this.loadUsuario();
          }
        }).catch(error => {
          console.error(error);
          this.messageService.add({ severity: 'system error', summary: 'Se presentó algun error', detail: error, life: 9000 });
        });

    }
  }

  deleteUsuario(user: Usuario) {
    this.confirmationService.confirm({
      message: '¿ ' + this.lbl_are_you_sure + ' ' + this.lbl_delete_record + ' ' + this.lbl_user + ' ' + user.login + ' ?',
      header: this.lbl_confirm,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      acceptLabel: this.lbl_yes,
      rejectLabel: this.lbl_no,
      accept: () => {
        this.apiService.deleteUser(user).then(
          user => {

            this.messageService.add({ severity: 'success', summary: this.lbl_delete_record, detail: this.lbl_record + this.lbl_deleted , life: 3000 });
            this.loadUsuario();

          });
      }
    });
  }


  exportPdf() {
    if (this.usuarioDocList === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.usuarioDocList.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.usuarioDocList.map((item) => ({
        "LOGIN": item ? (item?.login || 'S/N') : 'S/N',
        "NAME": item ? (item?.name || 'S/N') : 'S/N',
        "LAST_NAME": item ? (item?.lastName || 'S/N') : 'S/N',
        "ROL": item ? (item?.rol || 'S/N') : 'S/N',
        "GUIDE_ID": item ? (item?.guideId || 'S/N') : 'S/N',
        "EMAIL": item ? (item?.email || 'S/N') : 'S/N',
        "SUPPLY_ID": item ? (item?.supplId || 'S/N') : 'S/N',
      }));

      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listUsers_');

    }
  }

  exportExcel() {
    if (this.usuarioDocList === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.usuarioDocList.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.usuarioDocList.map((item) => ({
        "LOGIN": item ? (item?.login || 'S/N') : 'S/N',
        "NAME": item ? (item?.name || 'S/N') : 'S/N',
        "LAST_NAME": item ? (item?.lastName || 'S/N') : 'S/N',
        "ROL": item ? (item?.rol || 'S/N') : 'S/N',
        "GUIDE_ID": item ? (item?.guideId || 'S/N') : 'S/N',
        "EMAIL": item ? (item?.email || 'S/N') : 'S/N',
        "SUPPLY_ID": item ? (item?.supplId || 'S/N') : 'S/N',
      }));

      this.filesService.tovpilExportXLSX(filteredJSON, 'listUsers_');

    }
  }
  /** GENERAL FUNCTIONS */

  /**
   * The function retrieves security data for the current user and then calls two other functions.
   */
  getSecurity() {
    this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
      data => {
        this.security = data;
        this.loadUsuario();
        this.getTranslatedLabels();
        this.listCategoryTranslation('usrTypes');
        this.listAllDataGuidesbySupStore();
        this.getAllSupplier();
      });
  }

  /**
   * This function retrieves translations for a list of labels and updates the corresponding variables
   * with the translated values.
   */
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_total, this.lbl_records, this.lbl_showing, this.lbl_of, this.lbl_login, this.lbl_name, this.lbl_last_name, this.lbl_type, this.lbl_guideId, this.lbl_email, this.lbl_vendor, this.lbl_edit, this.lbl_delete_record, this.lbl_users, this.lbl_new_record, this.lbl_save, this.lbl_back, this.lbl_detail, this.lbl_user, this.lbl_confirm, this.lbl_are_you_sure, this.lbl_yes, this.lbl_no, this.lbl_status, this.lbl_loading, this.lbl_search, this.lbl_entry, this.lbl_userId, this.lbl_password, this.lbl_updated_data, this.lbl_record, this.lbl_deleted]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_records = map.get(this.lbl_records);
        this.lbl_showing = map.get(this.lbl_showing);
        this.lbl_of = map.get(this.lbl_of);
        this.lbl_login = map.get(this.lbl_login);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_last_name = map.get(this.lbl_last_name);
        this.lbl_type = map.get(this.lbl_type);
        this.lbl_guideId = map.get(this.lbl_guideId);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_vendor = map.get(this.lbl_vendor);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_delete_record = map.get(this.lbl_delete_record);
        this.lbl_users = map.get(this.lbl_users);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_back = map.get(this.lbl_back);
        this.lbl_detail = map.get(this.lbl_detail);
        this.lbl_user = map.get(this.lbl_user);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_yes = map.get(this.lbl_yes);
        this.lbl_no = map.get(this.lbl_no);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_loading = map.get(this.lbl_loading);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_entry = map.get(this.lbl_entry);
        this.lbl_userId = map.get(this.lbl_userId);
        this.lbl_password = map.get(this.lbl_password);
        this.lbl_updated_data = map.get(this.lbl_updated_data);
        this.lbl_record = map.get(this.lbl_record);
        this.lbl_deleted = map.get(this.lbl_deleted);

      });
  }
  goBack() {
    window.close();
  }
  listAllDataGuidesbySupStore() {
    this.apiService.listAllDataGuidesbySupStore({ "storeId": this.security.storeId }).then(
      data => {
        this.lstGuides = data;

        this.lstGuides = this.lstGuides.map((gui: any) => {
          return {
            ...gui,
            name: gui.guideName + ' ' + gui.guideLastName + ' : ' + gui.zoneName + ' - ' + gui.natioName + ' - ' + gui.localName + ' - ' + gui.livingCountry
          };
        });

      });
  }
  filterGui(event) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.lstGuides.length; i++) {
      let gui = this.lstGuides[i]; // Original data from service
      if (gui.name.toLowerCase().includes(query.toLowerCase())) {
        filtered.push(gui);
      }
    }

    this.filteredGuides = filtered;
  }
  getAllSupplier() {
    this.apiService.getAllSupplier().then(
      data => {
        this.lstSuppliers = data;
      });
  }
  showSupplOrGuide() {
    this.showGuides = false;
    this.showSuppliers = false;
    if (this.selectedUserType.valueId == Constants.USER__TYPE_GUI_FG) {
      this.selectedSupplier = {};
      this.showGuides = true;
    } else if (this.selectedUserType.valueId == Constants.USER__TYPE_SUPPLIER) {
      this.selectedGuide = {};
      this.showSuppliers = true;
    } else if (this.selectedUserType.valueId == Constants.USER__TYPE_ADMIN) {
      this.selectedSupplier = {};
      this.selectedGuide = {};
    }
  }
  enable() {
    this.apiService.changeUserStatus(
      {
        "userId": this.userView.login,
        "status": 'A',
        "language": this.security.language
      }
    ).then(
      data => {
        if (data && data.status && (data.status == Constants.EXCEPTION_ERROR || data.status == Constants.ERRORSTATUS)) {
          this.messageService.add({ severity: 'error', summary: 'System Error', detail: data.errorMessage, life: 9000 });
        } else{
          this.hideDialog();
          this.loadUsuario();
        }
      });
  }
}